module.exports = __webpack_public_path__ + "assets/images/match-field-sponsor-mapei.b48e0558ef2e35efdd258136c451a5a7.jpg";